/**
 * Time and theme utility functions
 */

/**
 * Get current theme based on time of day
 */
export const getTimeBasedTheme = () => {
    const hour = new Date().getHours();

    if (hour >= 6 && hour < 17) {
        return 'morning'; // 6 AM - 5 PM
    } else if (hour >= 17 && hour < 20) {
        return 'evening'; // 5 PM - 8 PM
    } else {
        return 'night'; // 8 PM - 6 AM
    }
};

/**
 * Format relative time (e.g., "2 days ago")
 */
export const getRelativeTime = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 60) {
        return diffMins <= 1 ? 'Just now' : `${diffMins} minutes ago`;
    } else if (diffHours < 24) {
        return diffHours === 1 ? '1 hour ago' : `${diffHours} hours ago`;
    } else if (diffDays < 7) {
        return diffDays === 1 ? 'Yesterday' : `${diffDays} days ago`;
    } else if (diffDays < 30) {
        const weeks = Math.floor(diffDays / 7);
        return weeks === 1 ? '1 week ago' : `${weeks} weeks ago`;
    } else {
        return date.toLocaleDateString();
    }
};

/**
 * Estimate reading time for text content
 */
export const estimateReadingTime = (text) => {
    if (!text) return '1 min read';

    const wordsPerMinute = 200;
    const words = text.trim().split(/\s+/).length;
    const minutes = Math.ceil(words / wordsPerMinute);

    return `${minutes} min read`;
};
